// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e055a967","239":"b24535e8","732":"c00ebc59"}[chunkId] + ".chunk.js";
};